"use client";

import { useEffect } from 'react';

/**
 * Weglot (intégration JS côté client) traduit parfaitement une page au
 * CHARGEMENT complet, mais pas après une navigation « soft » de l'App Router
 * Next.js : le nouveau contenu reste en français alors que le sélecteur indique
 * NL/EN. Aucune API Weglot (switchTo/search/translate) ne rétablit l'état après
 * une navigation SPA.
 *
 * Solution fiable : lorsqu'une langue TRADUITE est active, on force un
 * chargement complet du navigateur sur les liens internes (Weglot ré-initialise
 * et traduit alors la page comme au premier chargement). En langue source (FR),
 * on laisse la navigation SPA rapide de Next.js intacte.
 */
export default function WeglotRouteSync() {
  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      // Laisse passer les clics modifiés (nouvel onglet, etc.) et non primaires.
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) {
        return;
      }

      const w = (window as any).Weglot;
      if (!w || typeof w.getCurrentLang !== 'function') return;
      const current = w.getCurrentLang();
      const source = (w.options && (w.options.language_from || w.options.languageFrom)) || 'fr';
      // En langue source, on ne touche à rien (SPA normale).
      if (!current || current === source) return;

      const target = e.target as HTMLElement | null;
      const anchor = target && target.closest ? (target.closest('a') as HTMLAnchorElement | null) : null;
      if (!anchor) return;

      const href = anchor.getAttribute('href');
      if (!href) return;
      if (anchor.target && anchor.target !== '_self') return;
      if (anchor.hasAttribute('download')) return;

      let url: URL;
      try {
        url = new URL(anchor.href, window.location.href);
      } catch {
        return;
      }
      // Liens externes : comportement natif.
      if (url.origin !== window.location.origin) return;
      // Ancre sur la même page (#…) : on laisse le défilement natif.
      if (url.pathname === window.location.pathname && url.hash) return;

      // Langue traduite + lien interne : on force un chargement complet pour
      // que Weglot traduise la nouvelle page.
      e.preventDefault();
      window.location.assign(url.href);
    };

    document.addEventListener('click', onClick, true);
    return () => document.removeEventListener('click', onClick, true);
  }, []);

  return null;
}
